import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IAllowWorkbookAccelerationParams {
  targetIds: string[];
}

export class AdminAllowDataAccelerationForViews extends Request<IAllowWorkbookAccelerationParams, IResult> {
  constructor(params: IAllowWorkbookAccelerationParams) {
    super('allowDataAccelerationForViews', params);
  }
}
